import React, { use } from "react";
import StyledToggleButton, { StyledToggleButtonGroup } from "./StyledToggleButtonGroup";
import { DeviceContext } from "@/hooks/common/DeviceContext";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';

interface TogglePageProps {
  value: string;
  handleChange: (event: React.MouseEvent<HTMLElement>, newValue: string | null) => void;
  showTranscripts?: boolean; // Optional prop to control transcript tab visibility
  showExtensionRequests?: boolean; // Show the Extension Requests tab (admin only)
}

const Show = ({ when, children }: {
  when: boolean,
  children: React.ReactNode
}) => when ? <>{children}</> : null

export const TogglePage = ({ value, handleChange, showTranscripts = true, showExtensionRequests = false }: TogglePageProps) => {
  const { isMobile } = use(DeviceContext) ?? { isMobile: false, isTablet: false };
  const smallScreen = isMobile;

  const tabs = [
    {
      value: "Videos",
      label: "Videos",
      icon: <VideocamOutlinedIcon />,
      display: true
    },
    {
      value: "Images",
      label: "Images",
      icon: <InsertPhotoOutlinedIcon />,
      display: true
    },
    {
      value: "Transcripts",
      label: "Transcripts",
      icon: <DescriptionOutlinedIcon />,
      display: showTranscripts
    },
    {
      value: "ExtensionRequests",
      label: "Extension Requests",
      icon: <VideoLibraryOutlinedIcon />,
      display: showExtensionRequests
    },
  ].filter(Boolean);

  return (
    <div className="flex mt-0 mb-0">
      <StyledToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        style={{ boxShadow: "0px 0px 13.9px 0px #00000040" }}
      >
        {tabs.map(({ value, label, icon, display }) => (
          display && (
            <StyledToggleButton
              key={value}
              value={value}
              aria-label={`${value.toLowerCase()} tab`}
            >
              <Show when={smallScreen}>
                <span className="text-[18px]">{icon}</span>
              </Show>
              <Show when={!smallScreen}>
                {label}
              </Show>
            </StyledToggleButton>
          )
        ))}
      </StyledToggleButtonGroup>
    </div>
  )
}
